export default {
  title: 'Price List',
  box: {
    full: {
      title: 'Full Portfolio Analysis',
      content: 'Retrieving data from the Insurance Mountain (Har HaBituach) and the pension clearing house and in-depth analysis of the information, review of costs, management fees, investment tracks, alternatives for managing available funds, wills and inheritance, real estate, defining financial goals and building a risk management budget.',
      price: '₪5,000',
    },
    risk: {
      title: 'Risk and Health Portfolio Analysis',
      content: 'Comparing costs against alternatives, checking for duplicate coverage and presenting to the client, retrieving data from the Insurance Mountain (Har HaBituach), sending powers of attorney to the companies, reconciling with bank charges.',
      price: '₪3,000',
    },
    retire: {
      title: 'Retirement Planning',
      content: 'Examining alternatives upon retirement while minimizing tax liability, separating provident and severance funds by designation for capital and annuity, reviewing Form 161. Accompanying the client before the tax authorities when needed.',
      price: '₪4,500 - ₪10,000',
    },
    escort: {
      title: 'Ongoing Support at a Fixed Cost',
      content: 'Availability and personal service, all actions performed at no additional cost, an annual service meeting, updating and adjusting the insurance/pension portfolio.',
      price: '₪500 - ₪1,000 per person per month',
    },
    once: {
      title: 'One-time / Periodic Service Meeting for Non-clients of the Agency',
      content: 'A personal meeting at the request of a client who is not a client of the agency.',
      price: '₪380 per hour',
    },
    home: {
      title: 'First Meeting Hour at the Client\'s Home',
      content: 'Getting acquainted, aligning expectations and deciding on a support strategy. Gedera to Hadera (beyond these limits).',
      price: '₪700 - ₪1,000',
    },
    office: {
      title: 'First Meeting Hour at the Office',
      content: 'Getting acquainted, aligning expectations and deciding on a support strategy.',
      price: '₪500',
    },
    year: {
      title: 'Annual Service Meeting',
      content: 'Preparing a consolidated coverage report on the client\'s portfolio at the agency.',
      price: '₪500',
    },
    subscription: {
      title: 'Appointment as Agent for Existing Policies of a New Client',
      content: 'Taking over an existing policy for ongoing handling.',
      price: '₪350 - ₪550',
    },
    external: {
      title: 'Handling a Claim on an External Policy',
      content: 'Handling, guidance and assistance in filing a claim to exercise rights for pension, disability, survivors, long-term care, health, loss of working capacity, personal accidents and more (payable in installments, up to 36 payments).',
      price: '20% success fee',
    },
  },
};
